import { fetchWithAuth } from "../apiutil";

export const annotationsAPI = {
  /**
   * Load annotations for a clip
   * @param {string} accessToken - Authentication token
   * @param {number} caseId - Case ID
   * @param {number} clipId - Clip ID
   * @returns {Promise<Object>} Response with annotations data
   */
  loadAnnotations: async (accessToken, caseId, clipId) => {
    console.log(
      `[annotationsAPI.loadAnnotations] Loading annotations for clip ${clipId}`
    );

    const endpoint = `/api/cases/${caseId}/clips/${clipId}/annotations`;
    return await fetchWithAuth(endpoint, { method: "GET" }, accessToken);
  },

  /**
   * Save annotations to server (bulk update)
   * @param {string} accessToken - Authentication token
   * @param {number} caseId - Case ID
   * @param {number} clipId - Clip ID
   * @param {Array} annotations - Array of annotation objects
   * @returns {Promise<Object>} Response with updated annotations
   */
  saveAnnotations: async (accessToken, caseId, clipId, annotations) => {
    console.log(
      `[annotationsAPI.saveAnnotations] Saving ${annotations.length} annotations for clip ${clipId}`
    );

    const endpoint = `/api/cases/${caseId}/clips/${clipId}/annotations`;
    return await fetchWithAuth(
      endpoint,
      {
        method: "PUT",
        body: JSON.stringify(annotations),
      },
      accessToken
    );
  },

  /**
   * Delete a specific annotation
   * @param {string} accessToken - Authentication token
   * @param {number} caseId - Case ID
   * @param {number} clipId - Clip ID
   * @param {string} annotationId - Annotation ID to delete
   * @returns {Promise<Object>} Response indicating success/failure
   */
  deleteAnnotation: async (accessToken, caseId, clipId, annotationId) => {
    console.log(
      `[annotationsAPI.deleteAnnotation] Deleting annotation ${annotationId} for clip ${clipId}`
    );

    const endpoint = `/api/cases/${caseId}/clips/${clipId}/annotations/${annotationId}`;
    return await fetchWithAuth(endpoint, { method: "DELETE" }, accessToken);
  },
};
